import { render, staticRenderFns } from "./waitDealFeedbackEdit.vue?vue&type=template&id=a0ad31e2&"
import script from "./waitDealFeedbackEdit.vue?vue&type=script&lang=js&"
export * from "./waitDealFeedbackEdit.vue?vue&type=script&lang=js&"
import style0 from "./waitDealFeedbackEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports